/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [
  {
    action: 'createCustomerPartners',
    message: messages.SUCCESS_CREATE_CUSTOMER_PARTNERS,
    method: 'POST',
    path: '/customer/:customerId/partners',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.CREATE_CUSTOMER_PARTNER,
    requestSchema: requestSchemas.customerPartners.createCustomerPartners,
  },
  {
    action: 'getCustomerPartnersBySystemGameId',
    message: messages.SUCCESS_GET_CUSTOMER_PARTNERS_BY_SYSTEM_GAME_ID,
    method: 'GET',
    path: '/customer/:customerId/partners/:systemGameId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_CUSTOMER_PARTNER,
    requestSchema: requestSchemas.customerPartners.getCustomerPartnersBySystemGameId,
    scopes: [scopes.DEFAULT],
  },
  {
    action: 'recoverCustomerPartnersBySystemGameId',
    message: messages.SUCCESS_RECOVER_CUSTOMER_PARTNERS_BY_SYSTEM_GAME_ID,
    method: 'PATCH',
    path: '/customer/:customerId/partners/:systemGameId/recover',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.RECOVER_CUSTOMER_PARTNER,
    requestSchema: requestSchemas.customerPartners.recoverCustomerPartnersBySystemGameId,
  },
  {
    action: 'removeCustomerPartnersBySystemGameId',
    message: messages.SUCCESS_REMOVE_CUSTOMER_PARTNERS_BY_SYSTEM_GAME_ID,
    method: 'PATCH',
    path: '/customer/:customerId/partners/:systemGameId/remove',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.REMOVE_CUSTOMER_PARTNER,
    requestSchema: requestSchemas.customerPartners.removeCustomerPartnersBySystemGameId,
  },
];
